<div
  class="h-full flex flex-col gap-2"
  cdkDropList
  [id]="dropListId()"
  [cdkDropListData]="actions()"
  [cdkDropListDisabled]="disableControls()"
  (cdkDropListDropped)="handleActionDropped($event)"
>
  <ng-template #actionTemplate let-action>
    @if (action.type === 'stop') {
      <button
        mat-icon-button
        [disabled]="disableControls()"
        (click)="handleActionDelete(action)"
        matTooltip="Actie verwijderen"
      >
        <mat-icon>delete</mat-icon>
      </button>
    } @else {
      <button
        mat-icon-button
        [matMenuTriggerFor]="actionMenu"
        [disabled]="disableControls()"
        matTooltip="Meer"
      >
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #actionMenu="matMenu">
        <button mat-menu-item (click)="handleActionEdit(action)">Bewerken</button>
        <button mat-menu-item (click)="handleActionDelete(action)">Verwijderen</button>
      </mat-menu>
    }
  </ng-template>
  @for (action of actions(); track $index) {
    <div cdkDrag [cdkDragData]="action" cdkDragPreviewContainer="parent">
      @switch (action.type) {
        @case ('speak') {
          <app-speak-action [data]="action" [actions]="actionTemplate" />
        }
        @case ('audio') {
          <app-audio-action
            [data]="action"
            [actions]="actionTemplate"
            [isPlaying]="isPlaying() && currentTrackId() === action.value.fileId"
            (playChange)="handleAudioPlayback($event)"
          />
        }
        @case ('goto-question') {
          <app-goto-question-action
            [data]="action"
            [questions]="questions()"
            [actions]="actionTemplate"
          />
        }
        @case ('goto-interaction') {
          <app-goto-interaction-action [data]="action" [actions]="actionTemplate" />
        }
        @case ('notification-sms') {
          <app-notification-sms-action [data]="action" [actions]="actionTemplate" />
        }
        @case ('stop') {
          <app-stop-action [data]="action" [actions]="actionTemplate" />
        }
        @case ('image') {
          <app-image-action [data]="action" [actions]="actionTemplate" />
        }
      }
    </div>
  } @empty {
    <div class="empty-dropzone flex-1 flex flex-col items-center justify-center p-6 text-gray-500 border-2 border-dashed border-gray-300 rounded-lg min-h-[120px] bg-gray-50 transition-colors duration-200">
      <mat-icon class="mb-2 text-gray-400 transition-colors duration-200">touch_app</mat-icon>
      <span class="text-sm">Sleep hier een actie naartoe</span>
    </div>
  }
</div>
